import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CORE_SERVER_PREFIX}/seed-preservation`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    getPreviousSeedPreservationData: () => `${RESOURCE_ENDPOINT}/get-previous-seed-preservation-data`,
    getSeedPreservationDataForProduction: () => `${RESOURCE_ENDPOINT}/get-seed-preservation-data-for-production`,
    getSeedPreservationBlockData: () => `${RESOURCE_ENDPOINT}/get-seed-preservation-block-data`,
    preferenceCropVarietyList: () => `${RESOURCE_ENDPOINT}/upazila-wise-variety-preference`,
}

export default class SeedPreservationApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any, params = {}): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url, params);
    }

    public create = (payload: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

    public getPreviousSeedPreservationData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPreviousSeedPreservationData();
        return HttpService.get(url, params, headers);
    }

    public getSeedPreservationDataForProduction = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSeedPreservationDataForProduction();
        return HttpService.get(url, params, headers);
    }

    public getSeedPreservationBlockData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSeedPreservationBlockData();
        return HttpService.post(url, payload, params, headers);
    }

     public preferenceCropVarietyList = (params = {}, headers = {}): AxiosPromise<any> => {
            const url = endpoints.preferenceCropVarietyList();
            return HttpService.get(url, params, headers);
    }
}
